import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '../../../node_modules/@angular/common/http';



@Component({
  selector: 'app-endpoint-for-password-reset',
  templateUrl: './endpoint-for-password-reset.component.html',
  styleUrls: ['./endpoint-for-password-reset.component.css']
})
export class EndpointForPasswordResetComponent implements OnInit {



  constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient) { }



  ngOnInit() {
    // Send the post request to SIS to reset the student's password
    // Doing it this way, to the path /resetSisPassword instead of the full path, avoids CORS errors.
    // This path is set up in the firebase.json file to direct to the cloud function.
    // Meaning - this request WILL NOT WORK ON LOCAL HOST - it will only work when deployed to Firebase.
    this.http.post('/resetSisPassword', {token: this.route.snapshot.params.token}).subscribe(
      data => {
        // If we receive 'false' as a response, it did not validate the token and reset the password - we need an admin to look at the logs and see why
        if (!data) {
          
          console.log('Failed to reset password - got FALSE back');
          alert('Error resetting password, please contact an adminstrator at mis@elevenfifty.org');

        } else {
          // We received login credentials for the user
          
          console.log('Successfully received data from backend! That data is:')
          console.log(data)

          alert('Your password has been reset, you will now be redirected to the login page. You can log in using the password "password" and then you will be prompted to re-create your own password.');
          window.location.href = 'https://www.elevenfiftysis.org/fmwebd_home.html';

        }
      },
      err => { alert('Error resetting password, please contact an adminstrator at mis@elevenfifty.org'); console.log('error in POST request to pass loginToken to backend, inside ngOnInit(), inside login-by-token.component.ts.'); console.log(err); },
      () => console.log('Completed POST request to pass loginToken to backend, inside ngOnInit(), inside login-by-token.component.ts.')
    )
  }



}
